module.exports = __webpack_public_path__ + "img/kiwi-bird.84fb4cc9.svg";